import { produce } from 'immer';
import { DraftState } from '@/types';
import { DraftReducer } from './types';
import { validateDraft } from './validateDraft';

export const reducer: DraftReducer = (draft, action) =>
  produce(draft, (writableDraft: DraftState) => {
    const newDraft = action(writableDraft);
    // actions only return a draft if it is replaced completely, e.g. undo/redo
    if (newDraft) {
      return newDraft;
    }

    validateDraft(writableDraft, draft);
  });
